<template>
  <el-row type="flex" justify="center" v-loading="loading">
    <el-col :span="24" v-show="!loading && !isContractAlreadySigned && !isOfferExpired">
      <el-container   class="card auto-width">
        <TradeInfoRow :customerName="customerName" :currentTimestamp="currentTimestamp" :itemCount="totalItemCount"
          :totalTradeInOfferCredit="totalTradeInOfferCredit" />
        <el-row>
          <el-col>
            <p>
              Thank you for bringing in your items to <b>labelswap™</b>. In our
              world you are now known as a SELLER. Once accepted by an
              associate, your items are in the system to be reviewed. Your items
              will be sorted and potentially selected for purchase based on
              condition, style, store need, and demand for resale. Items we
              select and approve for purchase will be logged into our system
              which will help us determine current inventory, demand, and a
              suggested resale price. You will be provided with an offer sheet
              which provides you options to accept cash or store credit for the
              items we accept. In most cases, the store credit option will
              result in a higher payout to SELLER. SELLERS who chose store
              credit can utilize the credit immediately or labelswap™ will hold
              the credit value for a maximum period of 12 months. The credit
              expires 12 months from the date the credit is given and will not
              be honored after that date. The credit has no separate cash value.
              Multiple credits can be stacked if you are banking for a larger
              purchase.
            </p>

            <p>
              SELLERS are required to accept our Terms of Service to initiate
              the process, produce a valid photo ID, and provide your contact
              information including a valid telephone and email address to be
              eligible for <b>labelswap™</b> service. Unselected items will be
              donated / disposed of according to the Terms of Service, which is
              subject to change.
            </p>

            <p>
              SELLERS can drop off items and a Labelswap associate will contact
              you via telephone, text, or email to let you know your items have
              been processed, usually within 24 hours. If you choose to drop off
              items you agree to the same terms of services outlined below.
            </p>

            <p>
              For fastest service, please do not bring your items in on hangers
              or in storage containers. We cannot be responsible for items being
              misplaced, returning hangers, or returning containers so please
              consider this when preparing for a visit to <b>labelswap™</b>.
            </p>

            <p>
              Items that are not selected by <b>labelswap™</b> must be picked up
              within 24 hours of the notice time or they will be donated. If you
              are unable to pick up your items and contact the store within the
              24-hour period, your items will be held for one additional 24-hour
              period only.
            </p>

            <h1>labelswap™ TERMS OF SERVICE</h1>

            <p>
              SELLERS AGREE TO SELL THEIR ITEMS FOR THE PRICE SET BY
              <b>labelswap™</b> OR ACCEPT THE CREDIT VALUE PROVIDED BY
              <b>labelswap™</b> AT THE TIME OF THE TRANSACTION. CREDIT VALUE CAN
              BE USED IMMEDIATELY OR HELD AT THE STORE FOR A MAXIMUM OF 12
              MONTHS.
            </p>

            <p>
              SELLERS AUTHORIZE <b>labelswap™</b> TO CHOOSE, TAG, AND SELL THE
              ITEMS THEY SELECT IN EXCHANGE FOR THE VALUE OFFERED.
            </p>
            <p>
              <b>labelswap™</b> WILL HAVE CUSTOMER PAYMENT AVAILABLE AT THE
              CONCLUSION OF THE PROCESS ONLY. CUSTOMER WILL RECEIVE A PHONE
              CALL, EMAIL, OR TEXT MESSAGE (ONE ONLY) INDICATING THE PROCESS HAS
              BEEN COMPLETED.
            </p>
            <p>
              ITEMS NOT SELECTED BY <b>labelswap™</b> WILL BE RETURNED TO
              CUSTOMER IN A TIMELY MANNER OR DONATED OR DISPOSED OF 24 HOURS
              AFTER NOTICE IS SENT TO YOU OF COMPLETION OF THE PROCESS. IF
              CUSTOMER CANNOT RETRIEVE ITEMS IN THIS PERIOD CUSTOMER MUST
              CONTACT THE STORE IMMEDIATELY. IF CUSTOMER CONTACTS THE STORE
              WITHIN 24 HOURS, THE ITEMS WILL BE HELD FOR AN ADDITIONAL 24 HOURS
              ONLY AND WILL THEN BE DONATED OR DISPOSED OF. NO REQUESTS FOR
              ADDITIONAL EXTENSIONS OF TIME WILL BE HONORED.
            </p>
            <p>
              ONCE THE PROCESS HAS BEEN COMPLETED, CUSTOMER WILL NOT BE ABLE TO
              RECLAIM ITEMS FROM THE RACK, SHELVES OR DISPOSAL / DONATION BIN.
            </p>
            <p>
              CUSTOMER MUST PROVIDE VALID PHOTO IDENTIFICATION PAYMENT AND AS
              REQUIRED BY LAW.
            </p>
            <p>
              BY SIGNING BELOW, CUSTOMER REPRESENTS, WARRANTS AND AGREES THAT:
              (1) HE OR SHE HAS CLEAR, UNENCUMBERED TITLE TO ALL PROPERTY BEING
              SOLD, TRADED, OR CREDITED; (2)HAS THE RIGHT TO SELL OR EXCHANGE
              THE PROPERTY TO <b>LABELSWAP™</b>; THAT ALL PROPERTY HAS BEEN
              LEGALLY OBTAINED; (3) THAT ALL BRANDED GOODS ARE GENUINE AND DO
              NOT INFRINGE ANY PATENT, TRADEMARK, COPYRIGHT OR OTHER
              INTELLECTUAL PROPERTY RIGHTS; AND, (4) ALL KNOWN MATERIAL DEFECTS
              HAVE BEEN DESCRIBED OR MADE KNOWN AND NOT CONCEALED. IF AN ITEM IS
              DETERMINED TO BE COUNTERFEIT, THE STORE CREDIT WILL BE REMOVED
              FROM THE SELLERS ACCOUNT.
            </p>
            <p>
              CUSTOMER AGREES TO INDEMNIFY AND HOLD (<b>LABELSWAP™</b>), ITS
              EMPLOYEES, OFFICERS, AND THE BUYER OF THE GOODS (THE “INDEMNIFIED
              PARTIES”) HARMLESS FROM ANY CLAIM TO OWNERSHIP OF THE GOODS SOLD
              BY CUSTOMER OR ANY CLAIM THAT THE GOODS VIOLATE THE INTELLECTUAL
              PROPERTY OF ANY PERSON OR ENTITY AND SHALL DEFEND AND INDEMNIFY
              EACH INDEMNIFIED PARTY INCLUDING PAYMENT OF DEFENSE COSTS AS
              INCURRED.
            </p>
            <p>
              CUSTOMER WAIVES ANY CLAIM AGAINST THE INDEMNIFIED PARTIES FOR ANY
              AND ALL LOSS OR DAMAGE TO CUSTOMER PROPERTY DURING THE DROP OFF
              PERIOD OR SALE PROCESS. CUSTOMER AUTHORIZES <b>LABELSWAP™</b>, ITS
              ASSIGNS, SUCCESSORS, OR SERVICING AGENTS TO COMMUNICATE VIA SMS
              TEXT NOTIFICATION TO ANY NUMBER PROVIDED TO LABELSWAP. CUSTOMER
              AGREES TO ACCEPT ANY AND ALL CHARGES OR FEES ASSOCIATED WITH
              MOBILE COMMUNICATION FROM <b>LABELSWAP™</b> INCLUDING FEES FROM
              MOBILE SERVICE PROVIDERS.
            </p>
          </el-col>
        </el-row>
        <TradeInfoRow :customerName="customerName" :currentTimestamp="currentTimestamp" :itemCount="totalItemCount"
          :totalTradeInOfferCredit="totalTradeInOfferCredit" />
        <el-row>
          <canvas ref="canvas" @mousedown="startDrawing" @mousemove="draw" @mouseup="stopDrawing"
            @touchstart="startDrawing" @touchmove="draw" @touchend="stopDrawing" />
        </el-row>
        <el-row type="flex" justify="space-between" class="button-row">
          <el-button type="info" @click="clearCanvas"> Clear </el-button>
          <el-button type="primary" :disabled="!hasDrawn" @click="submitSignature">
            I agree
          </el-button>
        </el-row>
      </el-container>
    </el-col>
    <el-button v-if="!loading && !isAtBottom && !isContractAlreadySigned && !isOfferExpired" type="primary" icon="el-icon-arrow-down" circle class="float-button"
      @click="scrollToBottom" />
    <el-col style="margin-top: 200px;" :span="24" v-show="!loading && isContractAlreadySigned">
      <h2>The offer is already signed</h2>
    </el-col>
    <el-col style="margin-top: 200px;" :span="24" v-show="!loading && isOfferExpired">
      <h2>The offer has expired</h2>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from "vuex";
import TradeInfoRow from "../components/TradeInfoRow.vue";

export default {
  name: "BuyOfferPage",
  data() {
    return {
      loading: false,
      drawing: false,
      hasDrawn: false,
      context: null,
      x: 0,
      y: 0,
      isAtBottom: false,
      customerName: "",
      currentTimestamp: new Date().toLocaleString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      }),
      totalItemCount: 1,
      totalTradeInOfferCredit: null,
      isOfferExpired: false,
      isContractAlreadySigned: false,
    };
  },
  computed: {
    ...mapGetters("shopper", ["searchError"]),
    ...mapGetters("shopper", ["buyTradeOffer"]),
  },
  mounted() {
    // set loading to true
    this.loading = true;

    // get id from url
    const { id } = this.$route.params;
    // make api call to get trade offer details
    this.$store.dispatch("shopper/getBuyTradeOfferDetails", id).then(() => {
      const tradeOffer = this.$store.getters["shopper/buyTradeOffer"];
      this.totalItemCount = tradeOffer.item_count;
      this.customerName = tradeOffer.customer_name;
      this.totalTradeInOfferCredit = tradeOffer.store_credit_amount;
      this.isOfferExpired = tradeOffer.is_offer_expired;
      this.isContractAlreadySigned = tradeOffer.is_contract_already_signed;
      // set loading to false
      this.loading = false;
    });

    const { canvas } = this.$refs;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width;
    canvas.height = rect.height;
    this.canvas = canvas;
    this.context = canvas.getContext("2d");
    window.addEventListener("scroll", this.checkScrollPosition);
  },
  beforeDestroy() {
    // Detach the scroll event listener
    window.removeEventListener("scroll", this.checkScrollPosition);
  },
  methods: {
    preventScroll(event) {
      event.preventDefault();
    },
    startDrawing(event) {
      event.preventDefault(); // Prevent default behavior
      this.drawing = true;
      this.setCoordinates(event);
      this.canvas.addEventListener("touchstart", function (event) {
        event.preventDefault();
      });
      this.canvas.addEventListener("touchmove", function (event) {
        event.preventDefault();
      });
      this.canvas.addEventListener("touchend", function (event) {
        event.preventDefault();
      });
      this.canvas.addEventListener("touchcancel", function (event) {
        event.preventDefault();
      });
    },
    draw(event) {
      event.preventDefault(); // Prevent default behavior
      if (!this.drawing) return;
      this.context.beginPath();
      this.context.moveTo(this.x, this.y);
      this.setCoordinates(event);
      this.context.lineTo(this.x, this.y);
      this.context.stroke();
      this.context.closePath();
      this.hasDrawn = true;
    },
    stopDrawing(event) {
      event.preventDefault(); // Prevent default behavior
      this.drawing = false;
      this.context.beginPath();
      document.removeEventListener("touchmove", this.preventScroll);
      document.removeEventListener("mousemove", this.preventScroll);
    },
    setCoordinates(event) {
      const rect = this.$refs.canvas.getBoundingClientRect();
      const scaleX = this.$refs.canvas.width / rect.width;
      const scaleY = this.$refs.canvas.height / rect.height;
      if (event.touches) {
        this.x = (event.touches[0].clientX - rect.left) * scaleX;
        this.y = (event.touches[0].clientY - rect.top) * scaleY;
      } else {
        this.x = (event.clientX - rect.left) * scaleX;
        this.y = (event.clientY - rect.top) * scaleY;
      }
    },
    clearCanvas() {
      this.context.clearRect(
        0,
        0,
        this.$refs.canvas.width,
        this.$refs.canvas.height
      );
      this.hasDrawn = false;
    },
    async submitSignature() {
      // Capture canvas data
      const canvasData = this.$refs.canvas.toDataURL();

      if (!canvasData) {
        return;
      }

      // Simulate POST request to a fake backend
      try {
        const { id } = this.$route.params;

        console.log(id);

        console.log("Signature data sent to the backend: ", canvasData);

        this.$store
          .dispatch("shopper/signBuyTradeOffer", { id, signature: canvasData })
          .then(() => {
            alert("Trade complete! There is no need to return to the store, Thank you from labelswap™. ");
            window.location.href = "https://labelswap.com";
          });
      } catch (error) {
        alert("An error occurred while submitting the signature.");
      }
    },
    scrollToBottom() {
      // Scroll to the bottom of the page
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    },
    checkScrollPosition() {
      const { scrollHeight } = document.documentElement;
      const { scrollTop } = document.documentElement;
      const { clientHeight } = document.documentElement;

      // Check if user is at the bottom of the page (with a 100px offset to prevent the button from overlapping the footer content)
      this.isAtBottom = Math.ceil(scrollTop + clientHeight) >= (scrollHeight - 100);
    },
  },
  components: {
    TradeInfoRow,
  },
};
</script>

<style scoped lang='scss'>
.logo-and-title {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

canvas {
  width: 100%;
  min-height: 400px;
  border: 1px solid #000;
}

el-button[type="text"] {
  background-color: white;
  color: black;
  border: 1px solid black;
}

.float-button {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 999;
}

.info-row {
  margin-top: 20px;
  margin-bottom: 20px;

  p {
    margin: 2px 0;
  }
}
</style>
